import React from 'react'
import { useQuery } from '@tanstack/react-query'
import { format } from 'date-fns'
import { FiMap } from 'react-icons/fi'
import Card from '../../../components/Card'
import { api, authHeaders } from '../../../services/api'
import Spinner from '../../../components/Spinner'
import Table from '../../../components/Table'

export default function () {
	const { data: acessos } = useQuery({
		queryKey: ['obter-acessos-ao-prontuario-emergencia'],
		queryFn: async () => {
			try {
				const response = await api.get('prontuario_acesso', authHeaders())

				return response.map(item => ({
					id: item.id,
					nome: item.nome || 'não capturado',
					cpf: item.cpf || 'não capturado',
					dataHora: format(new Date(item.createdAt), 'dd/MM/yyyy HH:mm\'h\''),
					linkMaps: item.lat && item.lng ? `https://www.google.com/maps?q=${item.lat},${item.lng}` : null
				}))
			} catch(e) {
				console.log(e)
			}
		}
	})

	if(!acessos) {
		return <Spinner />
	}

	return (
		<div className="my-8 md:mx-16 lg:mx-24 flex flex-col items-center sm:pl-12 md:pl-0 min-h-[49vh]">
			<Card className="flex flex-col gap-6 bg-white text-slate-800">
				<h1 className="font-bold text-center text-slate-800" style={{ fontSize: 16 }}>Acessos ao seu QRCode de emergência</h1>

				<Table 
					headers={[
						{ name: 'nome', value: 'Nome' },
						{ name: 'cpf', value: 'CPF' },
						{ name: 'dataHora', value: 'Data e horário' }
					]}
					hideOnSmallHeaders={['cpf']}
					hideHeadersOffset={640}
					data={acessos}
					actions={item => item.linkMaps ? [
						{
							action: item => {
								window.open(item.linkMaps, '_blank')
							},
							name: 'Abrir mapa',
							icon: FiMap,
							iconSize: 16
						}
					] : []}
					hideOffset={400}
					emptyLabel="Nenhum acesso registrado"
				/>
			</Card>
		</div>
	)
}
